import setClipboardData from './set-clipboard-data';

export default {
  setClipboardData,
};
